import { makeStyles } from "@material-ui/core";
import { Form, Input, Row, Col, Button, Select } from "antd";
import { get } from "jquery";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import config from "../../config";
import { postcodeValidator } from "postcode-validator";
import { useCountry } from "../../provider/courtryProvider";

const useStyles = makeStyles((theme) => ({
  formInput: {
    border: "1px solid #000",
    borderRadius: 8,
  },
  formItem: {
    fontWeight: 700,
    "& .ant-col ant-col-24 ant-form-item-label": {
      padding: 0,
    },
  },
}));

function AddOutlet({
  show,
  handleClose,
  mode,
  initialValues = {},
  outlets,
  addOutlet,
  loading,
}) {
  const country = useCountry();
  const classes = useStyles();

  const checkOutlet = (userId, userPhoneNumber) => {
    let result;
    const outletByUserId = outlets.find((i) => i.userId === userId);
    const outletByPhoneNumber = outlets.find(
      (i) => i.userPhoneNumber === userPhoneNumber
    );
    console.log("outlets", outlets);
    console.log(
      "outletByUserId",
      outletByUserId,
      outletByPhoneNumber,
      userId,
      userPhoneNumber
    );
    if (mode === "edit") {
      if (outletByUserId && outletByPhoneNumber) {
        console.log(
          "outletByUserId",
          outletByUserId.userId,
          "outletByPhoneNumber",
          outletByPhoneNumber.userId
        );
        if (outletByUserId.userId === outletByPhoneNumber.userId) {
          result = false;
        } else {
          result = true;
        }
      } else {
        result = false;
      }
    } else {
      if (outletByPhoneNumber) {
        result = true;
      } else {
        result = false;
      }
    }

    return result;
  };

  const handleSubmit = async (values) => {
    console.log("values", values);
    const isExist = checkOutlet(initialValues.userId, values.userPhoneNumber);
    console.log("checkOutlet", isExist);
    if (isExist) {
      return alert("Employee is already exist in another outlet");
    }
    const getEmployee = employeeList.find(
      (i) => i.userPhoneNumber === values.userPhoneNumber
    );
    if (!getEmployee.userDesignation) {
      return alert("Please update the designation of employee");
    }
    const updateValues = {
      ...values,
      userName: getEmployee.userName,
    };
    addOutlet(updateValues, mode);
  };
  const [employeeList, setEmployeeList] = useState([]);
  const shopDetails = useSelector((state) => state.shopDetails);
  const fetchEmployee = async () => {
    try {
      var res = await fetch(
        `${config.newApiGateway}/employe/createEmployee-fetchEmployee`,
        {
          method: "post",
          body: JSON.stringify({
            shopId: shopDetails.shopId,
            action: "fetchEmployee",
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      res = await res.json();
      if (res.code === "SUCCESS") {
        setEmployeeList(res.data);
      } else {
        alert(res.message);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    if (shopDetails.shopId) {
      fetchEmployee();
    }
  }, [shopDetails.shopId]);

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton onClick={handleClose}>
        <Modal.Title>{mode === "add" ? "Add" : "Edit"} Outlet</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          name="basic"
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          initialValues={
            mode === "edit"
              ? {
                  ...initialValues,
                  userPhoneNumber: initialValues.userPhoneNumber,
                }
              : {}
          }
          onFinish={handleSubmit}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Select Employee"
                name="userPhoneNumber"
                className={classes.formItem}
                rules={[
                  {
                    required: true,
                    message: "Please select the employee!",
                  },
                ]}
              >
                <Select
                  size="large"
                  style={{
                    outline: "none",
                  }}
                  className={classes.formInput}
                >
                  {employeeList.map((i) => (
                    <Select.Option value={i.userPhoneNumber}>
                      {i.userName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Pincode"
                name="userPincode"
                className={classes.formItem}
                rules={[
                  {
                    required: true,
                    message: "Please input your Pincode!",
                  },
                  {
                    validator: async (_, value) => {
                      const validate = postcodeValidator(
                        value,
                        country.CountryCode
                      );
                      if (!validate) {
                        return Promise.reject(
                          new Error("Please Enter valid Pincode")
                        );
                      }
                    },
                  },
                ]}
              >
                <Input
                  type={"number"}
                  placeholder="Enter pincode"
                  size="large"
                  className={classes.formInput}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Area"
                name="outletArea"
                className={classes.formItem}
                rules={[
                  {
                    required: true,
                    message: "Please input your Outlet Area!",
                  },
                ]}
              >
                <Input
                  placeholder="Enter area"
                  size="large"
                  className={classes.formInput}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Outlet Address"
                name="shopAddress"
                className={classes.formItem}
                rules={[
                  {
                    required: true,
                    message: "Please input your Outlet Address!",
                  },
                ]}
              >
                <Input
                  placeholder="Outlet Address"
                  size="large"
                  className={classes.formInput}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="State"
                name="outletState"
                className={classes.formItem}
                rules={[
                  {
                    required: true,
                    message: "Please input your Outlet State!",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Enter state"
                  className={classes.formInput}
                />
              </Form.Item>
            </Col>
          </Row>
          <div
            style={{
              display: "flex",
              gap: "16px",
              justifyContent: "flex-end",
            }}
          >
            <Button
              style={{
                borderRadius: "8px",
              }}
              onClick={handleClose}
              type="primary"
              size="large"
            >
              Cancel
            </Button>

            <Button
              type="primary"
              size="large"
              style={{
                borderRadius: "8px",
                backgroundColor: "#EF4667",
                color: "#fff",
                border: "0",
              }}
              loading={loading}
              disabled={loading}
              htmlType="submit"
            >
              Submit
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default AddOutlet;
